<!--<div class="container-fluid">-->
<div id="page-container">
  <header>
    <div class="logo"><img src="assets/img/twpub_logo2.png" alt="TermWebPublish"></div>
  </header>
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav mode="side" opened class="sidenav">
      <mat-nav-list>
        <h3 mat-subheader>Administration</h3>
        <a mat-list-item [routerLink]="['/admin/home']" routerLinkActive="active">
          <mat-icon matListItemIcon>home</mat-icon>
          <span matListItemTitle>Admin Home</span>
        </a>
        <a mat-list-item [routerLink]="['/admin/layouts']" routerLinkActive="active">
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle>Page Layouts</span>
        </a>
        @if (termSuggestionsEnabled) {
          <a mat-list-item [routerLink]="['/admin/suggestions']" routerLinkActive="active">
            <mat-icon matListItemIcon>lightbulb</mat-icon>
            <span matListItemTitle i18n="@@admin.menu.suggestions">Term Suggestions</span>
          </a>
        }
        <h3 mat-subheader>Synchronization</h3>
        <a mat-list-item [routerLink]="['/admin/settings']" routerLinkActive="active">
          <mat-icon matListItemIcon>settings</mat-icon>
          <span matListItemTitle>Settings</span>
        </a>
        <a mat-list-item [disabled]="!isConfigurationOk" [routerLink]="['/admin/dictionaries']"
          routerLinkActive="active">
          <mat-icon matListItemIcon>translate</mat-icon>
          <span matListItemTitle>Dictionaries</span>
        </a>
        <a mat-list-item [disabled]="!isConfigurationOk" [routerLink]="['/admin/fields']"
          routerLinkActive="active">
          <mat-icon matListItemIcon>manage_search</mat-icon>
          <span matListItemTitle>Searchable Fields</span>
        </a>

        <mat-divider></mat-divider>

        @if (isSuperAdmin) {
          <a mat-list-item [routerLink]="['/superadmin']" routerLinkActive="active">
            <mat-icon matListItemIcon>supervisor_account</mat-icon>
            <span matListItemTitle>Tenant Management</span>
          </a>
        }

        <a mat-list-item [routerLink]="['/']" queryParamsHandling="merge" [queryParams]="{config:configId}">
          <mat-icon matListItemIcon>search</mat-icon>
          <span matListItemTitle>Back to Search</span>
        </a>
        @if (canLogOut) {
          <a mat-list-item (click)="logoutUser()">
            <mat-icon matListItemIcon>exit_to_app</mat-icon>
            <span matListItemTitle>Sign out</span>
          </a>
        }
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <footer>
    <div>{{ title }}</div>
    {{ versionStr }}
  </footer>
</div>
